/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useRef, useContext } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import { BiTrash, BiPlus } from "react-icons/bi";
import { Form, Table, OverlayTrigger } from "react-bootstrap";
import { RISKPARAMCOLORS } from "../../../../core/constants/common";
import Utils from "../../../../core/utilities/Utils";
import { RegulationContext } from "../../../../App";
import ConfirmationModal from "../../../../components/ConfirmationModal/ConfirmationModal";
import { BsQuestionCircle } from "react-icons/bs";

const AddRiskParameter = ({
  t,
  regulation,
  handleDiscard,
  editRiskId,
  handleSave,
  type,
  addRiskParent,
  configType,
}) => {
  // const [inputFields, setInputFields] = useState([
  //   { resultType: "", colorCode: "", minScore: "", maxScore: "" },
  // ]);
  const [inputFields, setInputFields] = useState([]);
  const [isEdit, setIsEdit] = useState(editRiskId ? true : false);
  const [name, setName] = useState("");
  const [score, setScore] = useState("");
  const [weightage, setWeightage] = useState("");
  const [regulationId, setRegulationId] = useState(regulation);
  const [riskDetails, setRiskDetails] = useState([]);
  const [checkEdit, setCheckEdit] = useState(false);
  const [checkActive, setCheckActive] = useState(true);
  const [checkShowInProfile, setShowInProfile] = useState(true);
  const [disableScore, setDisableScore] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [messageConfirmation, setMessageConfirmation] = useState("");
  const containerRef = useRef(null);
  var data = JSON.parse(localStorage.getItem("authority"));
  const { glbRegulations, setGlbRegulations } = useContext(RegulationContext);

  useEffect(() => {
    setIsEdit(editRiskId ? true : false);
    setName("");
    setScore("");
    setWeightage("");
    setCheckEdit("");
    setInputFields([]);
    setShowInProfile(true);
    setCheckActive(true);
    setCheckEdit(false);
    setDisableScore(false);
    editRiskId && getRiskDetails(regulationId, editRiskId);
    editRiskId && setIsEdit(true);
    containerRef.current.scrollIntoView();
  }, [editRiskId]);

  const getRiskDetails = (regId, editId) => {
    RiskConfigService.getRiskDetails(regId, editId, configType)
      .then((response) => {
        setInputFields([]);
        setRiskDetails(response.data);
        setName(response.data.name);
        setScore(response.data.maxScore);
        setWeightage(response.data.weightage);
        setCheckEdit(response.data.mandatory);
        //  response.data.children === null && response.data.active === true
        if (response.data.children === null) {
          setDisableScore(false);
        } else {
          const result = response.data.children.filter(
            (item) => item.active === false
          );
          if (response.data.children.length === result.length) {
            setDisableScore(false);
          } else {
            setDisableScore(true);
          }
        }
        response.data.mandatory === true
          ? setCheckEdit(true)
          : setCheckEdit(false);
        response.data.active === true
          ? setCheckActive(true)
          : setCheckActive(false);
        response.data.showInProfile === true
          ? setShowInProfile(true)
          : setShowInProfile(false);
        response.data.resultConfigs &&
          setInputFields(response.data.resultConfigs);
      })
      .catch((error) => { });
  };
  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };
  const addNewCategory = (e) => {
    e && e.preventDefault();
    let newfield = {
      resultType: "",
      colorCode: "",
      minScore: "",
      maxScore: "",
    };
    setInputFields([...inputFields, newfield]);
  };
  const removeCategory = (index, e) => {
    e.preventDefault();
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };
  const closeAddRiskParameter = (e) => {
    e.preventDefault();
    handleDiscard(true);
  };

  const saveRiskParameter = (e) => {
    e.preventDefault();
    let validateRisk = validateRiskCategory();
    if (name && validateRisk && score > 0 && weightage <= 100) {
      const rand = Math.floor(Math.random() * 999) + 100;
      var params = {
        code: rand,
        dataPoint: true,
        maxScore: score,
        name: name,
        resultConfigs: inputFields,
        weightage: weightage,
        mandatory: checkEdit,
        showInProfile: checkShowInProfile,
        active: checkActive,
        type: configType.toUpperCase(),
      };
      if (type === "RISK") {
        params.parent = {
          id: addRiskParent,
        };
      }
      // console.log(params);
      saveParameter(params, regulationId);
    }
    setValidated(true);
  };
  const saveParameter = (params, regId) => {
    RiskConfigService.addRiskParameter(params, regId)
      .then((response) => {
        if (response.status === 201) {
          setGlbRegulations(response.data);
          response.data.parent
            ? handleSave(response.data.parent.id)
            : handleSave("");
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setName("");
          setScore("");
          setWeightage("");
          setInputFields([]);
          setValidated(false);
        }
      })
      .catch((error) => { });
  };
  const editParameter = (params, regId) => {
    RiskConfigService.editRiskParameter(regId, editRiskId, params, configType)
      .then((response) => {
        if (response.status === 200) {
          setGlbRegulations(response.data);
          response.data.parent
            ? handleSave(response.data.parent.id)
            : handleSave("");
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => { });
  };
  const editRiskParameter = (e) => {
    e.preventDefault();
    let validateRisk = validateRiskCategory();
    if (name && validateRisk && score > 0 && weightage <= 100) {
      riskDetails.maxScore = score;
      riskDetails.name = name;
      riskDetails.resultConfigs = inputFields;
      riskDetails.weightage = weightage;
      riskDetails.mandatory = checkEdit;
      riskDetails.active = checkActive;
      riskDetails.mandatory = checkEdit;
      riskDetails.showInProfile = checkShowInProfile;
      if (type === "RISK") {
        riskDetails.parent.id = addRiskParent;
      }
      editParameter(riskDetails, regulationId);
    }
    setValidated(true);
  };
  const handleEditClick = () => {
    setCheckEdit(!checkEdit);
  };
  const validateRiskCategory = () => {
    if (inputFields.length > 0) {
      let validate = inputFields?.map((input, index) => {
        if (input.colorCode === null || input.colorCode === "") {
          return false;
        } else if (input.resultType === null || input.resultType === "") {
          return false;
        } else if (
          input.minScore === null ||
          input.minScore === "" ||
          input.minScore < 0 ||
          input.minScore > 10
        ) {
          return false;
        } else if (
          input.maxScore === null ||
          input.maxScore === "" ||
          input.maxScore < 0 ||
          input.maxScore > 10
        ) {
          return false;
        } else {
          return true;
        }
      });

      return validate.includes(true);
    } else {
      addNewCategory();
      return false;
    }
  };
  const handleCheckActive = (e) => {
    let val = e.currentTarget.checked;
    if (riskDetails.childrenCount > 0) {
      if (val === false) {
        setMessageConfirmation(t("DisableParamMsg.label"));
        setIsConfirmation(true);
      } else {
        setCheckActive(val);
      }
    } else {
      if (val === false) {
        setMessageConfirmation(t("DisableChildParamMsg.label"));
        setIsConfirmation(true);
      } else {
        setCheckActive(val);
      }
    }
  };
  const handleActive = (val) => {
    setIsConfirmation(false);
    val && setCheckActive(false);
  };
  return (
    <>
      <div className="AddRiskparameter_box" id="idRiskParam" ref={containerRef}>
        <Form noValidate validated={validated}>
          <div className="row m-0">
            <div className="col-lg-6 p-2">
              <span className="py-1 d-block">
                <label className="mb-1">{t("RiskParameter.label")}</label>&nbsp;*
                <OverlayTrigger
                  placement="top"
                  overlay={Utils.renderTooltip(t("RiskParameterName.label"))}
                >
                  <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                </OverlayTrigger>
              </span>

              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={t("Enterparametername.label")}
                required
                maxLength={250}
              />
            </div>
            <div className="col-lg-3 p-2">
              <span className="py-1 d-block">
                <label className="mb-1">{t("Maxscore.label")}</label>&nbsp;*
                <OverlayTrigger
                  placement="top"
                  overlay={Utils.renderTooltip(t("Maxscore.label"))}
                >
                  <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                </OverlayTrigger>

              </span>

              <input
                type="number"
                className="form-control"
                value={score}
                onChange={(e) => setScore(e.target.value)}
                disabled={disableScore ? "disabled" : ""}
                required
                min="0"
              />
            </div>
            <div className="col-lg-3 p-2">

              <span className="py-1 d-block">
                <label className="mb-1">{t("Weightage.label")}</label>&nbsp;*
                <OverlayTrigger
                  placement="top"
                  overlay={Utils.renderTooltip(t("WeightageInPercent.label"))}
                >
                  <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                </OverlayTrigger>
              </span>

              <input
                type="number"
                className="form-control"
                value={weightage}
                onChange={(e) => setWeightage(e.target.value)}
                required
                min="0"
                max="100"
              />
            </div>
          </div>

          <div className="row m-0">
            <div className="col-lg-12 p-2">
              <div className="card p-0 Risk_category-addRSW_01 ">
                <Table responsive="sm">
                  <thead>
                    <tr>
                      <th>
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("RiskCategoryInfo.label")
                          )}
                        >
                          <span>{t("RiskCategory.label")}*</span>
                        </OverlayTrigger>
                      </th>
                      <th>{t("Color.label")} *</th>
                      <th className="text-center">
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("RiskCategoryMinMaxInfo.label")
                          )}
                        >
                          <span>{t("RiskScore.label")} *</span>
                        </OverlayTrigger>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields?.map((input, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={input.resultType}
                              name="resultType"
                              onChange={(event) =>
                                handleFormChange(index, event)
                              }
                              placeholder={t("Entercategoryname.label")}
                              required
                            />
                          </td>
                          <td>
                            <select
                              className="form-select"
                              defaultValue={input.colorCode}
                              onChange={(event) =>
                                handleFormChange(index, event)
                              }
                              name="colorCode"
                              required
                            >
                              <option value="" disabled hidden>
                                {t("Select.label")}
                              </option>
                              {RISKPARAMCOLORS.map(({ value, label }) => (
                                <option key={value} value={value}>
                                  {label}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <ul className="RiskScore_tb_inner">
                              <li>
                                {" "}
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="From"
                                  value={input.minScore}
                                  name="minScore"
                                  onChange={(event) =>
                                    handleFormChange(index, event)
                                  }
                                  required
                                  min="0"
                                  max="10"
                                />
                              </li>
                              <li> - </li>
                              <li>
                                {" "}
                                <input
                                  type="number"
                                  className="form-control"
                                  placeholder="To"
                                  value={input.maxScore}
                                  name="maxScore"
                                  onChange={(event) =>
                                    handleFormChange(index, event)
                                  }
                                  required
                                  min="0"
                                  max="10"
                                />
                              </li>
                            </ul>
                          </td>
                          <td>
                            <button
                              className="btn btn-blank_outline"
                              onClick={(e) => removeCategory(index, e)}
                            >
                              <BiTrash />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <div className="p-2">
                  <button
                    className="btn btn-secondary"
                    onClick={addNewCategory}
                  >
                    <BiPlus className="me-1"> </BiPlus> {t("New.label")}
                  </button>
                </div>
                <div className="p-2">
                  {data.roles.includes("SUPER_ADMIN") && (
                    <div className="pb-2 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        checked={checkEdit}
                        onChange={handleEditClick}
                      />

                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        {t("DisableEdit.label")}
                      </label>
                    </div>
                  )}
                  <div className="pb-2 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={checkShowInProfile}
                      onChange={() => setShowInProfile(!checkShowInProfile)}
                    />

                    <label
                      className="form-check-label"
                      htmlFor="exampleCheck1"
                    >
                      {t("ShowInDashboard.label")}
                    </label>
                  </div>
                  <div className="pb-2 form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={checkActive}
                      onChange={(e) => handleCheckActive(e)}
                    />

                    <label
                      className="form-check-label"
                      htmlFor="exampleCheck1"
                    >
                      {t("Active.label")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 p-2 text-center">
              <button
                className="btn btn-secondary me-2 px-3"
                onClick={closeAddRiskParameter}
              >
                {" "}
                {t("Discard.label")}
              </button>
              {isEdit ? (
                <button
                  className="btn btn-primary px-4"
                  onClick={editRiskParameter}
                >
                  {" "}
                  {t("Save.label")}
                </button>
              ) : (
                <button
                  className="btn btn-primary px-4"
                  onClick={saveRiskParameter}
                >
                  {" "}
                  {t("Save.label")}
                </button>
              )}
            </div>
          </div>
        </Form>
        {isConfirmation && (
          <ConfirmationModal
            modalShow={true}
            messageText={messageConfirmation}
            callbackModal={handleActive}
            confirmBtn={t("Yes.label")}
            CancelBtn={t("No.label")}
          />
        )}
      </div>
    </>
  );
};
AddRiskParameter.propTypes = {
  handleDiscard: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default withTranslation()(AddRiskParameter);
